import * as requestFromServer from "./saleStockChannelsCrud";
import { channelsState, callTypes } from "./saleStockChannelsSlice";
const { actions } = channelsState;

export const fetchChannels = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getAllChannels(queryParams)
    .then((response) => {
      const { totalCount, entities } = response.data;
    })
    .catch((error) => {});
};

export const setDefaultChannel = (defaultChannel) => (dispatch) => {
  dispatch(actions.setDefaultChannel({ defaultChannel }));
}